import * as styles from "./HeaderCell.module.scss";
import * as React from "react";

export const HeaderCell = (props: { cellValue: string }): JSX.Element => {
  return <div className={styles.headerCellWrapper}>{props.cellValue}</div>;
};
